<template>
  <artmisads-modal class="order-existed-tip-modal" :open="true" :title="st('campaigns.suspendConfirmTitle')" :width="720"
    :onCancel="props.hideOrderExistedTipModal" :destroyOnClose="true">
    <p>{{ st('finance.orderExistedPendingIntro') }}</p>
    <artmisads-table :data-source="props.orderList" :columns="columns" size="small">
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'billingDate'">
          <span class="billing-date" v-for="item in record.billDateList" :key="item">{{ item }}</span>
        </template>
        <template v-else-if="column.key === 'amount'">
          <span>{{ CURRENCY_DATA_MAPPER[record.currency] }}{{ record.amount }}</span>
        </template>
        <template v-else-if="column.key === 'createTime'">
          <span>{{ moment(record.sellerPaymentOrderVO.createTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
        </template>
        <template v-else-if="column.key === 'action'">
          <a class="pay-btn" :href="record.sellerPaymentOrderVO?.paymentUrl" target="_blank">{{ st('finance.orderExistedPay') }}</a>
        </template>
      </template>
    </artmisads-table>
    <p>{{ st('finance.orderExistedFooterHint') }}</p>
    <template #footer>
      <artmisads-button type="primary" @click="emit('createNewOrder', false)">{{ st('finance.orderExistedCreateNewOrder') }}</artmisads-button>
    </template>
  </artmisads-modal>
</template>

<script setup>
import { computed } from 'vue';
import moment from 'moment';
import { CURRENCY_DATA_MAPPER } from '@/contants/common';
import { useSellerI18n } from '@/composables/useSellerI18n';

const { st } = useSellerI18n();

const emit = defineEmits(['createNewOrder']);
const props = defineProps(["orderList", "hideOrderExistedTipModal"]);
const columns = computed(() => [
  {
    key: 'billingDate',
    title: st('finance.billingDate'),
    dataIndex: 'billDateList',
  },
  {
    key: 'amount',
    title: st('finance.colAmount'),
    dataIndex: 'amount',
  },
  {
    key: 'createTime',
    title: st('finance.orderExistedColCreateTime'),
    dataIndex: 'createTime',
  },
  {
    key: 'paymentMethod',
    title: st('finance.orderExistedColPaymentMethod'),
    dataIndex: 'paymentMethod',
  },
  {
    key: 'action',
    title: st('finance.orderExistedColAction'),
  },
]);
</script>

<style lang="less">
.order-existed-tip-modal {
  .ant-modal-body {
    padding-bottom: 4px !important;
  }
}
</style>
<style lang="less" scoped>
.artmisads-table {
  padding: 0;
  margin: 12px 0 24px;
  background: var(--bg-gray-6);

  :deep(.ant-table) {
    overflow: hidden;
    border-radius: 8px;
    border: 1px solid var(--border-4);

    th {
      padding: 0 8px;

      &:first-child {
        padding-left: 16px;
      }

      &:last-child {
        padding-right: 16px;
      }
    }

    .ant-table-tbody {
      td {
        padding: 8px;

        &:first-child {
          padding-left: 16px;
        }

        &:last-child {
          padding-right: 16px;
        }
      }
      >tr:last-child>td {
        border-bottom: none;
      }
    }

    .billing-date {
      display: block;
    }
  }
}

.pay-btn {
  color: var(--primary-text);
  text-decoration: underline;

  &:hover {
    color: var(--primary-hover);
  }
}
</style>